<script setup lang="ts">
import { computed, ref } from "vue";

const { source, disabled = false } = defineProps<{
  source: string | Blob;
  disabled?: boolean;
}>();

const clipboardItems = computed(() => {
  if (source instanceof Blob) {
    return [new ClipboardItem({ [source.type]: source })];
  }
  return [new ClipboardItem({ "text/plain": source })];
});

// `copied` and `copy` are provided by useClipboardItems but don't properly work for images
const copied = ref(false);

async function copy() {
  await navigator.clipboard.write(clipboardItems.value);
  copied.value = true;
  setTimeout(() => (copied.value = false), 2000);
}
</script>
<template>
  <button class="button" :disabled="disabled" @click="copy">
    <template v-if="copied"><slot name="copied" /></template>
    <template v-else><slot /></template>
  </button>
</template>
